import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectDependencyApps, selectDependencyTools, selectParentApp } from './hmiSlice';
import { incrementDaasStep, selectDaasSignup } from '../daasSignup/daasSignupSlice';
import { cancelDaasSignup } from '../../services/DaasSignupService';
import Hmi, { HmiType } from 'hmi';
import 'hmi/dist/hmi.cjs.development.css';
import { LoadingScreen } from '../../components/shared/LoadingScreen/LoadingScreen';
import { selectLanguage } from '../language/languageSlice';

export const HmiDaas: React.FC = () => {
  const language = useSelector(selectLanguage);
  const signup = useSelector(selectDaasSignup);
  const parentApp = useSelector(selectParentApp);
  const dependencyApps = useSelector(selectDependencyApps);
  const dependencyTools = useSelector(selectDependencyTools);
  const dispatch = useDispatch();

  if (
    !parentApp ||
    (parentApp.dependencies && parentApp.dependencies.plugs.length !== dependencyApps.length) ||
    (parentApp.dependencies && parentApp.dependencies.tools.length !== dependencyTools.length)
  ) {
    return <LoadingScreen messageId={'hatters.signup.loading'} />;
  }

  return (
    <>
      <Hmi
        applicationId={parentApp.id}
        hmiType={HmiType.registration.daas}
        parentApp={parentApp}
        language={language}
        dependencyTools={dependencyTools.map((tool) => tool.info.name)}
        dependencyApps={dependencyApps}
        onApproved={() => dispatch(incrementDaasStep(1))}
        onRejected={() => cancelDaasSignup(Object.assign({}, signup))}
      />
    </>
  );
};
